import React from 'react';
import StaticPage from './StaticPage';

/**
 * TCH-02-FR-02 requires acceptance of the Privacy Policy at registration.
 * Same reasoning as Terms: the route resolves, the text comes from the business.
 */
const Privacy: React.FC = () => (
  <StaticPage
    title="Aviso de Privacidad"
    intro="Cómo recopilamos, usamos y protegemos tus datos y los de tus hijos."
    pendingLegalCopy
  />
);

export default Privacy;
